import React from 'react';

interface IHistoryIconProps {
  width?: string;
  height?: string;
  fill?: string;
}

const HistoryIcon = ({ width = '16', height = '16', fill = '#CE181E' }: IHistoryIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.83969 1.99842C5.44636 1.90509 2.66636 4.63175 2.66636 7.99842H1.47303C1.17303 7.99842 1.02636 8.35842 1.23969 8.56509L3.09969 10.4318C3.23303 10.5651 3.43969 10.5651 3.57303 10.4318L5.43303 8.56509C5.63969 8.35842 5.49303 7.99842 5.19303 7.99842H3.99969C3.99969 5.39842 6.1197 3.29842 8.73303 3.33175C11.213 3.36509 13.2997 5.45175 13.333 7.93175C13.3664 10.5384 11.2664 12.6651 8.66636 12.6651C7.59303 12.6651 6.5997 12.2984 5.81303 11.6784C5.54636 11.4718 5.17303 11.4918 4.93303 11.7318C4.65303 12.0118 4.67303 12.4851 4.98636 12.7251C5.99969 13.5251 7.27303 13.9984 8.66636 13.9984C12.033 13.9984 14.7597 11.2184 14.6664 7.82509C14.5797 4.69842 11.9664 2.08509 8.83969 1.99842ZM8.49969 5.33175C8.22636 5.33175 7.99969 5.55842 7.99969 5.83175V8.28509C7.99969 8.51842 8.12636 8.73842 8.32636 8.85842L10.4064 10.0918C10.6464 10.2318 10.953 10.1518 11.093 9.91842C11.233 9.67842 11.153 9.37175 10.9197 9.23175L8.99969 8.09175V5.82509C8.99969 5.55842 8.77303 5.33175 8.49969 5.33175Z"
        fill={fill}
      />
    </svg>
  );
};

export default HistoryIcon;
